import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 100%;
  .notice {
    width: 100%;
  }
`;
export default {
    Wrapper,
};
